module.exports = __webpack_public_path__ + "img/description3.a1e7c9cb.jpg";